import Header from "../components/Header";
import Footer from "../components/Footer";
import SliderBanner from "../components/BannerComponent";

export default function ContactUs() {
  return (
    <>
      <Header />
      <SliderBanner />
      contact us
      <Footer />
    </>
  );
}
